'use strict';

var _ = require('lodash');
var FaresPanelService = function FaresPanelService(currentStateCriteriaService, SearchCriteriaRule) {
  var timeAndDateCategoryName = 'Time & Date';
  function getFaresChartSearchCriteria() {
    var criteria = currentStateCriteriaService.getSearchCriteria();
    var rules = criteria.rules;
    return _.filter(rules, function (rule) {
      return rule.category !== timeAndDateCategoryName;
    });
  }
  function getSearchCriteriaForGivenMarket(selectedMarket) {
    var criteria = currentStateCriteriaService.getSearchCriteria();
    var newCriteria = _.filter(criteria.rules, function (rule) {
      return rule.criterion !== 'Market';
    });
    var marketCriteriaElement = new SearchCriteriaRule({
      field: 'custom:faresMarket',
      operator: '=',
      leftOperand: selectedMarket
    });
    newCriteria.push(marketCriteriaElement);
    return newCriteria;
  }
  function filterByLocationCategory(searchCriteriaList) {
    return _.filter(searchCriteriaList, function (criteria) {
      return criteria.category !== 'Location';
    });
  }
  return {
    getFaresChartSearchCriteria: getFaresChartSearchCriteria,
    getSearchCriteriaForGivenMarket: getSearchCriteriaForGivenMarket,
    filterByLocationCategory: filterByLocationCategory
  };
};
FaresPanelService.$inject = ['CurrentStateCriteriaService', 'SearchCriteriaRuleFactory'];
module.exports = FaresPanelService;